import useTestWebhook from "@babackapp/private-api-client/client/use-test-webhook";
import type { ShopWebhookDto } from "@babackapp/private-api-client/types";
import useTranslation from "@babackapp/translations/use-translation";
import { Button } from "@babackapp/ui/components/button";
import {
	DropdownMenu,
	DropdownMenuContent,
	DropdownMenuItem,
	DropdownMenuLabel,
	DropdownMenuSeparator,
	DropdownMenuTrigger,
} from "@babackapp/ui/components/dropdown-menu";
import { ChevronDownIcon } from "@heroicons/react/24/solid";
import { useCurrentShopSuspense } from "@/api/shops/use-current-shop-suspense";

type WebhookEventTesterProps = {
	webhook: ShopWebhookDto;
};

export default function WebhookEventTester({
	webhook,
}: WebhookEventTesterProps) {
	const { data: shop } = useCurrentShopSuspense();
	const { mutateAsync: testWebhook } = useTestWebhook(shop);
	const t = useTranslation();

	return (
		<DropdownMenu>
			<DropdownMenuTrigger asChild>
				<Button size="sm" variant="outline">
					{t("settings.integrations.webhooks.menu.test")}
					<ChevronDownIcon className="size-4" />
				</Button>
			</DropdownMenuTrigger>
			<DropdownMenuContent className="pr-2">
				<DropdownMenuLabel>{t("misc.update")}</DropdownMenuLabel>
				<DropdownMenuSeparator />
				{webhook.subscriptions.map((subscription) => (
					<DropdownMenuItem
						onClick={() => {
							return testWebhook({
								event: subscription,
								webhookId: webhook.id!,
							});
						}}
						key={subscription}
						className="flex flex-col gap-1 justify-start min-w-56 text-left w-full"
					>
						<span className="text-sm text-left w-full">
							{t(`settings.integrations.webhooks.${subscription}`)}
						</span>
						<span className="text-xs text-left w-full text-muted-foreground">
							{subscription}
						</span>
					</DropdownMenuItem>
				))}
			</DropdownMenuContent>
		</DropdownMenu>
	);
}
